import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';

import {IconImage,IconArrow} from './Icons';
import PicturesBody from './PicturesBody';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Pictures extends Component {

  render() {

    const trans = this.trans;
    const t = this.t;

    return (
      <div className="bf-tools js-tools js-tools-open" ref={(div) => { this.toolBoxHandler = div; }} >
        <h6 className="tools-title js-tools-on-off">
          <IconImage/>
          Images
        </h6>
        <span className="tools-on-off js-tools-on-off">
          <IconArrow/>
        </span>
        <PicturesBody
          dictionaryStorage={this.props.dictionaryStorage}
        />

      </div>
    );
  }
}






